<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
      <el-form-item label="平台">
        <el-select v-model="formLabelAlign.platform_id" placeholder="请选择平台" filterable>
          <el-option
            v-for="item,index in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道号">
        <el-input v-model="formLabelAlign.channel_code" />
      </el-form-item>
      <el-form-item label="渠道名称">
        <el-input v-model="formLabelAlign.channel_name" />
      </el-form-item>
      <el-form-item label="优化师">
        <el-input v-model="formLabelAlign.optimizer" />
      </el-form-item>
    </el-form>
    <el-button type="primary" class="brwbtn" @click="addbtn">确 定</el-button>
  </div>
</template>

<script>
import { addchannelNumber } from '@/api/report/wechatUsers.js'
import { getchannelplatform } from '@/api/report/wechatUsers.js'
export default {
  components: {},
  data() {
    return {
      platformSelectList: [],
      labelPosition: 'right',
      formLabelAlign: {
        platform_id: null,
        channel_code: '',
        channel_name: '',
        optimizer: ''
      }
    }
  },
  created() {
    this.getpingtai()
  },
  mounted() {

  },
  methods: {
    // 获取平台数据
    getpingtai() {
      this.loading = true
      getchannelplatform().then(res => {
        this.platformSelectList = res.data.list
        this.loading = false
      })
    },
    async addbtn() {
      if (this.formLabelAlign.platform_id === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.formLabelAlign.channel_code === '') {
        this.$message.error('请填写渠道号')
        return
      }
      if (this.formLabelAlign.channel_name === '') {
        this.$message.error('请填写渠道名称')
        return
      }
      if (this.formLabelAlign.optimizer === '') {
        this.$message.error('请填写优化师')
        return
      }
      const data = await addchannelNumber(this.formLabelAlign)
      this.$emit('handle')
      this.$message.success('添加成功')
      this.formLabelAlign = {
        platform_id: null,
        channel_code: '',
        channel_name: '',
        optimizer: ''
      }
      console.log('data', data)
    }
  }
}
</script>
<style scoped lang="less">
.brwbtn{
  margin-left: 370px;
  margin-top: 10px;
}

</style>
